import { toJS } from 'mobx'
import React, { useEffect, useState } from 'react'
import { store } from '../../../../store/favor/store'
import { getQuoteList, getQuoteList_post } from '../../../../modules/quote/web'

export function FavorListHead() {
  const [newSortParam, setNewSortParam] = useState({
    newSortClass: '',
    newSortDir: ''
  })
  const [zfSortParam, setZFSortParam] = useState({
    zfSortClass: '',
    zfSortDir: 'up'
  })

  const onNewSort = async () => {
    setZFSortParam({
      ...zfSortParam,
      zfSortClass: ''
    })
    let param = toJS(store.param)
    param.st = 'f2'
    if (!newSortParam.newSortDir) {
      setNewSortParam({
        newSortClass: 'icons-index-down up',
        newSortDir: 'up'
      })
      param.sr = 0
    } else {
      setNewSortParam({
        newSortClass: 'icons-index-down',
        newSortDir: ''
      })
      param.sr = 1
    }
    resetParam(param)
    store.setParam(param)
    const newSortData = await getQuoteList_post(store.param, store.stockCodes)
    if(newSortData){
        store.setCurrentFavorList(newSortData.data.splice(0,store.param.psize))
        store.setFavorList(newSortData.data)
    }
  }

  const onZFSort = async () => {
    setNewSortParam({
      ...newSortParam,
      newSortClass: ''
    })
    let param = toJS(store.param)
    param.st = 'f3'
    if (!zfSortParam.zfSortDir) {
      setZFSortParam({
        zfSortClass: 'icons-index-down up',
        zfSortDir: 'up'
      })
      param.sr = 0
    } else {
      setZFSortParam({
        zfSortClass: 'icons-index-down',
        zfSortDir: ''
      })
      param.sr = 1
    }
    resetParam(param)
    store.setParam(param)
    const newSortData = await getQuoteList_post(store.param, store.stockCodes)
    if(newSortData){
        store.setCurrentFavorList(newSortData.data.splice(0,store.param.psize))
        store.setFavorList(newSortData.data)
    }
  }

  const resetParam = (param: { cmd: string; pindex: number; psize: number; sr: number; st: string }) => {
    param.psize = ((param.pindex <= 1 ? 2 : param.pindex) - 1) * param.psize
    param.pindex = 1
  }

  useEffect(() => {
    setNewSortParam({
      newSortClass: '',
      newSortDir: ''
    })
    setZFSortParam({
      zfSortClass: '',
      zfSortDir: 'up'
    })
  }, [store.newFavors])

  return (
    <dd className="list-head">
      <div>名称代码</div>
      <div data-dir={newSortParam.newSortDir} onClick={onNewSort}>
        最新<i className={`sprite-ico ${newSortParam.newSortClass}`}></i>
      </div>
      <div data-dir={zfSortParam.zfSortDir} onClick={onZFSort}>
        涨幅<i className={`sprite-ico ${zfSortParam.zfSortClass}`}></i>
      </div>
    </dd>
  )
}
